import {
  TextField as MuiTextField,
  type TextFieldProps as MuiTextFieldProps,
} from '@mui/material';
import { type UseControllerReturn } from 'react-hook-form';

type TextFieldProps = {
  field?: UseControllerReturn['field'];
  name: string;
  label: string;
  size?: 'small' | 'medium';
  error?: boolean;
  helperText?: string;
} & MuiTextFieldProps;

const TextField = ({
  field,
  label,
  size = 'small',
  error,
  helperText,
  ...props
}: TextFieldProps) => (
  <MuiTextField
    {...field}
    {...props}
    size={size}
    label={label}
    error={error}
    helperText={helperText}
  />
);

export default TextField;
